import { Modal } from '@acorns/web-components'
import styled from 'styled-components'

import Button from 'components/Button'
import Layout from 'components/Layout'
import Separator from 'components/Separator'
import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const ActionWrapper = styled.div`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background-color: white;
    bottom: 0;
    left: 0;
    padding: 15px 0 20px 0;
    position: fixed;
    width: 100%;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`

export const StyledBody = styled(Body)`
  font-size: 14px;
  line-height: 22px;
  margin: 0 auto 80px;
  max-width: 340px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 30px;
  }
`

export const StyledButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px 10px;
  width: 220px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    bottom: 15px;
    height: 44px;
    margin: 8px 20px 20px 20px;
    position: sticky;
    width: calc(100vw - 40px);
  }
`

export const StyledImage = styled.img`
  height: auto;
  margin: 40px auto 0;
  max-width: 275px;
  width: 100%;

  // iphone 5/SE
  @media (max-width: 320px) {
    margin-top: 20px;
  }
`

export const StyledLayout = styled(Layout)`
  padding: 10px 0px 14px 0px;
`

export const StyledModal = styled(Modal)`
  min-width: 500px;
  min-height: 634px;
  margin: 0 10px 0 0;
  overflow-y: none;
  text-align: left;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    margin-top: 20px;
    min-width: 80vw;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    min-width: calc(100vw - 40px);
    height: calc(100vh - 40px);
    margin: 0 auto;
    padding: 20px;

    .modal-close-button {
      top: 22px;
    }
  }
`

export const ModalButton = styled(Button)`
  margin: 0;
  width: 100%;
  top: 20px;
`

export const ModalTitle = styled.div`
  display: block;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  position: absolute;
  text-align: center;
  top: 25px;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    top: 22px;
  }
`

export const ModalSubtitle = styled.div`
  display: block;
  font-weight: 600;
  margin: 0 0 30px 0;
  line-height: 24px;
  width: 100%;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    top: 32px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
  }
`

export const ModalBody = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  overflow-y: auto;
  margin-bottom: 10px;
  padding-bottom: 20px;
  max-width: 400px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    font-size: 14px;
    max-width: 335px;
  }
`

export const ModalContent = styled.p`
  margin: 0 20px 20px 0;
`

export const ModalSeparator = styled(Separator)`
  margin: 25px 0 50px 0;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: block;
    margin: 44px 0 30px 0;
  }
`

export const StyledTitle = styled(Heading2)`
  font-size: 22px;
  line-height: 30px;
  margin: 35px auto 6px;
`

export const StyledTextButton = styled(Button)`
  line-height: 22px;
  height: 22px;
  margin-top: 20px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-top: 7px;
  }
`
